/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';
export interface IErrorAnalyticsPluginMethods extends IPluginMethodMap {
  getErrorAnalyticsSync(args?: any): any;
}

export class ErrorAnalyticsPlugin implements IAgentPlugin {
  readonly methods: IErrorAnalyticsPluginMethods;

  constructor() {
    this.methods = {
      getErrorAnalyticsSync: this.getErrorAnalyticsSync.bind(this),
    };
  }

  getErrorAnalyticsSync(args?: any) {
    return {
      // error:ErrorAnalyticsConfig
    };
  }
}
